<template>
  <product-list
    :productService = productService
    :productComponent = productComponent
  ></product-list>
</template>

<script>
  import ProductList from '@/components/Common/Rental/Products/Overview'
  import productService from '@/services/licensor/product'

  export default {
    components: {
      ProductList
    },
    data () {
      return {
        productService: productService,
        productComponent: 'LicensorProductSales'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Licensor/Products/Overview.vue